module.exports = __webpack_public_path__ + "images/emoji/sun_with_face.c34a4fc00d8544cf76c3.png";